import React, { createContext, useState, useContext, useEffect } from "react";
import { languageData } from "../data/languageData";

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState("id");
  const [translations, setTranslations] = useState(languageData["id"]);

  const changeLanguage = (lang) => {
    setCurrentLanguage(lang);
    setTranslations(languageData[lang]);

    // Update html lang attribute
    document.documentElement.lang = lang;

    // Update page title
    document.title = `SAKAKA - IT Solutions & SaaS Products ${lang === "en" ? "(English)" : "(Indonesia)"}`;
  };

  const translate = (key) => {
    return translations[key] || key;
  };

  const translateHTML = (key) => {
    return { __html: translations[key] || key };
  };

  useEffect(() => {
    // Initialize with Indonesian
    changeLanguage("id");
  }, []);

  const value = {
    currentLanguage,
    translations,
    changeLanguage,
    translate,
    translateHTML,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
